const commandBarStyles = {
  root: {
    backgroundColor: '#FAFAFA',
    paddingRight: '0px',
    Width: 'auto',
  },
};

const dropdownStyles = {
  root: {
    width: '30%',
    minWidth: '300px',
    maxWidth: 425,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

export { commandBarStyles, dropdownStyles };
